var dd = require('react-dd');
var _ = require('lodash');
var FormInputMixin = require('../FormInputMixin');

var placeholder_value = '__some$random$uuid__';

module.exports = {
	component: dd.createClass({
		mixins: [FormInputMixin],
		__onChange: function(e){
			var new_value = e.target.value;
			this._input_newValue(this.__isOption(new_value) ? new_value : null);
		},
		__getCountryList: function(){
			var field = this.props.field;
			var Displaylists = field.Displaylists;
			var u_lists = (Displaylists && Displaylists.universal) || {};
			return u_lists.countrylist || {};//It should come pre-sorted from the server
		},
		__isOption: function(value){
			return _.includes(_.map(this.__getCountryList(), 'sc'), value);
		},
		render: function(){
			var field = this.props.field;
			var value = this.props.value;

			if(field.read_only){
				return dd.p({className: 'form-control-static'},
					this.__isOption(value) ? _.find(this.__getCountryList(),function(country){
						return country.sc === value;
					}).lc : value
				);
			}

			value = this.__isOption(value) ? value : placeholder_value;

			return dd.select({
					className: 'form-control' + (field.disabled ? ' disabled' : ''),
					value: value,
					name: this.props.field_path,
					onChange: this.__onChange,
					disabled: field.disabled ? 'disabled' : null
				},
				dd.option({value: placeholder_value}, field.placeholder || '-- select country --'),
				_.map(this.__getCountryList(), function(country, i){
					return dd.option({key: i, value: country.sc}, country.lc);
				})
			);
		}
	}),
	validate: function(value){
		return !!value || 'Please select a country';
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/inputs/esCountry.js
// module id = 199
// module chunks = 0 1 2 3 4